import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";

const statusData = [
    { name: "Yet to start", value: 400 },
    { name: "In progress", value: 300 },
    { name: "Ready for production", value: 200 },
    { name: "In Production", value: 150 },
    { name: "Ready for dispatch", value: 110 },
    { name: "Dispatched/Delivered", value: 210 },
];

const STATUS_COLORS = [
    "#28a745",
    "#ffc107",
    "#0d6efd",
    "#dc3545",
    "#dc35d9ff",
    "#6f42c1",
];

const PieChartComponent = () => {
    return (
        <div className="card shadow-sm border-0">
            <div className="card-body">
                <h5 className="card-title">Order Status Distribution</h5>
                <PieChart width={350} height={400}>
                    <Pie
                        data={statusData}
                        cx="50%"
                        cy="50%"
                        innerRadius={60}
                        outerRadius={100}
                        paddingAngle={4}
                        dataKey="value"
                    >
                        {statusData.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={
                                    STATUS_COLORS[index % STATUS_COLORS.length]
                                }
                            />
                        ))}
                    </Pie>
                    <Tooltip />
                    <Legend />
                </PieChart>
            </div>
        </div>
    );
};

export default PieChartComponent;
